export const bulkIdRegisterReducerKey = 'bulkIdRegisterReducerKey';
export const bulkIdRegisterSetIpAddressReducerType = 'bulkIdRegisterSetIpAddressReducerType';
export const bulkIdRegisterSetDataReducerType = 'bulkIdRegisterSetDataReducerType';
export const bulkIdRegisterSetIsLoadingReducerType = 'bulkIdRegisterSetIsLoadingReducerType';
export const bulkIdRegisterSetLoginFailReducerType = 'bulkIdRegisterSetLoginFailReducerType';
export const errorMessage = 'You entered an invalid ID or password. Please try again.';
